import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
@Component({
  selector: 'app-search',
  template: `
    <div class="relative" (window:keydown.alt.f)="onFind($event)">
      <input (keydown.delete)="onClear($event)" #search type="text"
             [value]="value"
             maxlength="100"
        [attr.class]="'font-medium text-xs leading-3 text-[#929292] px-9 py-1.5 focus:outline-0 border border-[#E3E6EE] rounded-md flex gap-2.5 justify-start items-center w-full' + (class ? ' ' + class : '')"
        autocomplete="off" [placeholder]="placeHolder" name="search"  (input)="onInput($event)"
        class="" />
      <img src="../../../../assets/images/icons/tickets/search-black.svg" alt="search" class="absolute top-[5px] left-3" />

      <button [hidden]="!value" matTooltip="Clear (Delete)" (click)="clearSearch()" class="absolute top-[5px] right-3 size-4 flex items-center justify-center cursor-pointer">
        <img src="./assets/images/icons/global/popup-cross.svg" alt="clear" class="h-2.5 w-2.5" />
      </button>
    </div>
  `,
  styleUrls: ['./search.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchComponent),
      multi: true,
    },
  ],
})
export class SearchComponent implements ControlValueAccessor {
  modelChanged = new Subject<string>();
  @Output() search = new EventEmitter<string>();
  @ViewChild('search') searchInput: ElementRef<HTMLInputElement>;

  onChanged: any = () => {};
  onTouched: any = () => {};
  _disabled: boolean;
  @Input() class: string;
  private _value: string = '';

  public get value(): string {
    return this._value ?? '';
  }
  public set value(v: string) {
    this._value = v ?? '';
  }

  private _placeHolder: string = 'Search (Alt + F)';
  public get placeHolder(): string {
    return this._placeHolder;
  }
  @Input() public set placeHolder(v: string) {
    this._placeHolder = v;
  }

  constructor() {
    this.modelChanged.pipe(debounceTime(500)).subscribe(() => {
      this.onChange(this.value);
    });
  }

  onFind(event: Event) {
    event.preventDefault();
    this.focusSearchBox();
  }

  //gets the value from the formControl
  writeValue(val) {
    this.value = val;
  }

  registerOnChange(fn: any) {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  onChange(ev) {
    this.onTouched();
    this.onChanged(ev);
    this.search.emit(ev);
  }

  changed() {
    this.modelChanged.next(this.value);
  }

  clearSearch() {
    this.value = '';
    this.onChange(this.value);
    this.focusSearchBox();
  }

  onClear(event) {
    event.preventDefault();
    this.clearSearch();
  }

  onInput(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    this.value = val;
    this.changed();
  }

  focusSearchBox() {
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 100);
  }
}
